import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  AfterViewInit
} from '@angular/core';

@Component({
  selector: 'bepatient-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss'],
  standalone: false
})
export class ActivityComponent implements AfterViewInit {
  @Input() message: string;
  @Input() color: string;
  @Input() image: string;
  @Input() title: string;
  @Input() buttonLabel: string;

  @Output() validated = new EventEmitter<boolean>();

  @ViewChild('validationButton', { read: ElementRef, static: true })
  private validationButtonRef: ElementRef;

  ngAfterViewInit(): void {
    this.validationButtonRef.nativeElement.style.setProperty(
      '--background',
      this.color
    );
  }
}
